import { RcFile } from "antd/lib/upload"
import { UploadFileType } from "../../_webui/layout/components/Upload/models"

export const getFileNameRcFile = (obj: UploadFileType): obj is RcFile => {
  return typeof obj !== "string" && "name" in obj
}
